import { DEFAULT_EXAM_CATEGORIES } from "./defaults"
import type { ExamCategoryStore } from "./types"

export const EXAM_CATEGORIES_STORE_KEY = "shell:exam-content-categories:v5"

export function applyCanonicalDomainNames(categories: ExamCategoryStore): ExamCategoryStore {
  const canonicalById = new Map(
    DEFAULT_EXAM_CATEGORIES
      .filter((category) => category.parentId === null)
      .map((category) => [category.id, category.name]),
  )
  return categories.map((category) => {
    const canonical = canonicalById.get(category.id)
    if (!canonical || category.parentId !== null) return category
    const wordCount = category.name.trim().split(/\s+/).filter(Boolean).length
    if (wordCount <= 1 && canonical !== category.name) {
      return { ...category, name: canonical }
    }
    return category
  })
}

export function readExamCategoryStore(raw: string | null): ExamCategoryStore {
  if (!raw) return DEFAULT_EXAM_CATEGORIES.map((category) => ({ ...category }))
  try {
    const parsed = JSON.parse(raw) as ExamCategoryStore
    if (!Array.isArray(parsed) || parsed.length === 0) {
      return DEFAULT_EXAM_CATEGORIES.map((category) => ({ ...category }))
    }
    return applyCanonicalDomainNames(parsed)
  } catch {
    return DEFAULT_EXAM_CATEGORIES.map((category) => ({ ...category }))
  }
}
